<template>
    <div style="width: 100%; height: 100%; min-width: 1280px; padding: 10px;">
      <div style="display: flex; flex-direction: column; flex: 1; height: 100%; min-width: 1280px;">
        <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
          <e-columns>
					  <e-column field="updateDate" :headerText="$t('UpdateDate')" textAlign="Left" :customAttributes="customAttributes" width="170" type="datetime" :format="dateTimeFormatOptions"></e-column>
					  <e-column field="delayLogg" :headerText="$t('DelayLog')" textAlign="Left" :customAttributes="customAttributes" width="120" :template="delayLogTemplate"></e-column>
					  <e-column field="decValue" :headerText="$t('Dec.Value')" textAlign="Left" :customAttributes="customAttributes" width="130" :template="decValueTemplate"></e-column>
            <e-column field="incValue" :headerText="$t('Inc.Value')" textAlign="Left" :customAttributes="customAttributes" width="120" :template="incValueTemplate"></e-column>
					  <e-column field="delayOpen" :headerText="$t('DelayOpen')" textAlign="Left" :customAttributes="customAttributes" width="130" :template="delayOpenTemplate"></e-column>
					  <e-column field="stabilisationGap" :headerText="$t('StabilizationGap')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="stabilisationGapTemplate"></e-column>
					  <e-column field="emptyMangerWeight" :headerText="$t('MinMangerWeight')" textAlign="Left" :customAttributes="customAttributes" width="180" :template="emptyMangerWeightTemplate"></e-column>
					  <e-column field="calibrationWeight" :headerText="$t('CalibrationWeight')" textAlign="Left" :customAttributes="customAttributes" width="180" :template="calibrationWeightTemplate"></e-column>
					  <e-column field="maxEatingSpeedLogControl" :headerText="$t('MaxEatingSpeed')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="maxEatingSpeedLogControlTemplate"></e-column>
					  <e-column field="noControlOfLogBelowValue" :headerText="$t('NoControlOfLogBelow')" textAlign="Left" :customAttributes="customAttributes" width="220" :template="noControlOfLogBelowValueTemplate"></e-column>
					  <e-column field="stabilizationTime" :headerText="$t('StabilizationTime')" textAlign="Left" :customAttributes="customAttributes" width="170" :template="stabilizationTimeTemplate"></e-column>
					  <e-column field="wagonAutoCloseTime" :headerText="$t('WagonAutoCloseTime')" textAlign="Left" :customAttributes="customAttributes" width="210" :template="wagonAutoCloseTimeTemplate"></e-column>
					</e-columns>
        </ejs-grid>
		  </div>
    </div>
</template>

<script>
import {  getRoughageSettingsHistory } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'

export default {
  props: ['systemId', 'systemName'],
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
			    data: [],
          pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
          toolbar: [
            { text: this.$t('SettingsRoughage'), id: 'table-settings-title' },
            { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
            { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
            { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
            { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
            'Search',
          ],
          wrapSettings: { wrapMode: "Content" },
          selectionOptions: { type: "Multiple" },
          filterOptions: {
            type: "Menu",
          },
          customAttributes : {class: 'customcss'},
          sortingModes: [],
          dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
          decValueTemplate: function() {
              return {
                  template: Vue.component('decValueTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.decValue}}g/s
                          </div>
                          <div v-else>
                            {{data.decValue/1000}}lb/s
                          </div>
                      `
                  })
              }
          },
          incValueTemplate: function() {
              return {
                  template: Vue.component('incValueTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.incValue}}g/s
                          </div>
                          <div v-else>
                            {{data.incValue/1000}}lb/s
                          </div>
                      `
                  })
              }
          },
          maxEatingSpeedLogControlTemplate: function() {
              return {
                  template: Vue.component('maxEatingSpeedLogControlTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.maxEatingSpeedLogControl}}g/s
                          </div>
                          <div v-else>
                            {{data.maxEatingSpeedLogControl/1000}}lb/s
                          </div>
                      `
                  })
              }
          },
          calibrationWeightTemplate: function() {
              return {
                  template: Vue.component('calibrationWeightTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.calibrationWeight}}kg
                          </div>
                          <div v-else>
                            {{data.calibrationWeight}}lb
                          </div>
                      `
                  })
              }
          },
          noControlOfLogBelowValueTemplate: function() {
              return {
                  template: Vue.component('noControlOfLogBelowValueTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.noControlOfLogBelowValue}}g
                          </div>
                          <div v-else>
                            {{data.noControlOfLogBelowValue/1000}}lb
                          </div>
                      `
                  })
              }
          },
          stabilisationGapTemplate: function() {
              return {
                  template: Vue.component('stabilisationGapTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.stabilisationGap}}g
                          </div>
                          <div v-else>
                            {{data.stabilisationGap/1000}}lb
                          </div>
                      `
                  })
              }
          },
          emptyMangerWeightTemplate: function() {
              return {
                  template: Vue.component('emptyMangerWeightTemplate', {
                      template: `
                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">
                            {{data.emptyMangerWeight}}g
                          </div>
                          <div v-else>
                            {{data.emptyMangerWeight/1000}}lb
                          </div>
                      `
                  })
              }
          },
          delayLogTemplate: function() {
              return {
                  template: Vue.component('delayLogTemplate', {
                      template: `
                          <div>
                            {{data.delayLogg}}s
                          </div>
                      `
                  })
              }
          },
          delayOpenTemplate: function() {
              return {
                  template: Vue.component('delayOpenTemplate', {
                      template: `
                          <div>
                            {{data.delayOpen}}s
                          </div>
                      `
                  })
              }
          },
          stabilizationTimeTemplate: function() {
              return {
                  template: Vue.component('stabilizationTimeTemplate', {
                      template: `
                          <div>
                            {{data.stabilizationTime}}s
                          </div>
                      `
                  })
              }
          },
          wagonAutoCloseTimeTemplate: function() {
              return {
                  template: Vue.component('wagonAutoCloseTimeTemplate', {
                      template: `
                          <div>
                            {{data.wagonAutoCloseTime}}s
                          </div>
                      `
                  })
              }
          },
        }
    },
    methods: {
      async getData() {
        this.data = [];
        this.$emit('spin', true)

        var roughageSettingsHistory = await getRoughageSettingsHistory(this.systemId);
        this.data = roughageSettingsHistory;
        // console.log(this.data)
        this.$emit('spin', false)
      },
      toolbarClick: function(args) {
            switch(args.item.id){
                case "table-system-title":
                  this.$router.push({
                    name: "systems"
                  })
                  break;
                case "table-settings-title":
                  this.getData();
                  break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
      dataBound: function () {
        this.$refs.grid.autoFitColumns();
      },
    },
    mounted: async function() {
        await this.getData();
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/SettingsRoughage.vue